import MomentUtils from '@date-io/moment';
import { Button, TextField } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import _ from 'lodash';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import Select from 'react-select';
import { IState } from '../../redux/store';
import * as VarsActions from '../../redux/vars/vars.actions';
import { ICustomerContractFormDTO } from '../../repository/jago/model/input/ICustomerContractFormDTO';
import ReduxLanguage from "../ReduxLanguage";
import { Autocomplete } from '@material-ui/lab';
import translations from '../../translations/i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { CustomerContractStatusOptions } from '../../codec/customerContractInDTODecoder';
import { ICustomerInDTO } from '../../repository/jago/model/input/ICustomerInDTO';
import { ICustomerRequestParamsDTO } from '../../repository/jago/model/output/RequestParamsDTOs';
import { PaginatedDataDTO } from '@bottega52/commons-pagination';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '100%',
    flex: 1,
  },
  formTitle: {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  errorText: {
    color: 'red'
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: 'red'
  },
  inputTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  italicText: {
    fontStyle: 'italic',
  },
  customerDataColumn: {
    flex: 1,
  },
  actionButton: {
    width: 'fit-content',
    color: 'white',
    marginLeft: 20,
    padding: 4,
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: 'bold'
  },
  actionButtonText: {
    margin: 0,
    fontWeight: 'bold',
  },
  icon: {
    fontSize: 15,
    marginRight: 5,
  },
  iconCustomer: {
    marginRight: 5,
    fontSize: 25,
  },
  dateInput: {
    height: 33
  }
});

export interface ICustomerContractFormState {
  customerContract: ICustomerContractFormDTO;
  errors: Record<keyof ICustomerContractFormDTO, boolean>;
  customerSearchInput: string;
  customerSelected: ICustomerInDTO;
  customersLoading: boolean;
};

export interface ICustomerContractFormProps extends WithStyles<typeof styles>{
  onCreateEditCustomerContract: (customerContract: ICustomerContractFormDTO) => void;
  customerContract?: ICustomerContractFormDTO;
  customer?: ICustomerInDTO;
}

type IReduxProps = ConnectedProps<typeof connector>;

export type ComponentProps = ICustomerContractFormProps & IReduxProps;
class CustomerContractForm extends React.Component<ComponentProps, ICustomerContractFormState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      customerSearchInput: "",
      customerSelected: !props.customerContract && props.customer ? props.customer : null,
      customersLoading: false,
      customerContract: props.customerContract ? props.customerContract : {
        id: null,
        name: '',
        status: '',
        signingDate: null,
        expirationDate: null,
        activationDate: null,
        deactivationDate: null,
        customer: props.customer,        
      },
      errors: {
        id: null,
        name: null,
        status: null,
        signingDate: null,
        expirationDate: null,
        activationDate: null,
        deactivationDate: null,
        customer: null,
      },
    };
  }

  async onCustomerSearchInputChanged(newInputValue: string) {
    const { dispatch } = this.props;
    this.setState({ customerSearchInput: newInputValue })
    if (!newInputValue) {
      await dispatch<any>(VarsActions.resetCustomersSearch());
      this.setState({ customersLoading: false })
      return;
    }
    this.setState({ customersLoading: true })
    const params: ICustomerRequestParamsDTO = { name: newInputValue };
    await dispatch<any>(VarsActions.fetchCustomersSearch(params));
    this.setState({ customersLoading: false })
  }

  onChangeValue(field: keyof ICustomerContractFormDTO, mandatory: boolean, value?: any) {
    const { customerContract, errors } = this.state;
    this.setState({
      errors: { ...errors, [field]: !value && mandatory ? true : false }
    });
    (customerContract as any)[field] = value;
    this.setState({ customerContract });
  }

  onSubmitForm() {
    const { customerContract } = this.state;
    if (!this.canSubmitForm()) {
      return;
    }
    const { onCreateEditCustomerContract } = this.props;
    onCreateEditCustomerContract(customerContract);
  }

  canSubmitForm() {
    const { } = this.props;
    const { customerContract } = this.state;
    return customerContract.name && customerContract.status && customerContract.signingDate && customerContract.expirationDate;
  }

  public render() {
    const { classes, customersSearch } = this.props;
    const { customerContract, errors, customerSearchInput, customerSelected, customersLoading } = this.state;
    
    const isEdit = Boolean(this.props.customerContract)

    const customersSearchData = customersSearch && customersSearch.data && (customersSearch.data as PaginatedDataDTO<ICustomerInDTO>).content?
      (customersSearch.data as PaginatedDataDTO<ICustomerInDTO>).content : []

    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={moment.locale()}>
        <div className={classes.container}>
        <div style={{ flex: 0, marginRight: 10 }}>
            {!isEdit && !this.props.customer ? (
              <div style={{display:'flex',flexDirection:'column',marginTop:0}}>
                <h5 style={{ fontWeight: 'normal' }}>{<ReduxLanguage languageKey={'activations.customerSearch'} />}</h5>
                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                  <Autocomplete
                    id="customer-search"
                    style={{ width: '80%' }}
                    getOptionLabel={(option) => option.name}
                    filterOptions={(x) => (x as ICustomerInDTO[])}
                    options={customersSearchData}
                    autoComplete
                    loading={customersLoading}
                    disabled={Boolean(this.props.customer)}
                    includeInputInList
                    filterSelectedOptions
                    value={customerSelected}
                    noOptionsText={<ReduxLanguage languageKey={customerSearchInput?'activations.customerSearchNoMatch':'activations.customerSearchEnterName'} />}
                    onChange={(event, newValue) => {
                      this.setState({ customerSelected: !newValue?null:(newValue as ICustomerInDTO) });
                      this.onChangeValue('customer', true, !newValue ? null : (newValue as ICustomerInDTO))
                    }}
                    onInputChange={(event, newInputValue) => {this.onCustomerSearchInputChanged(newInputValue)}}
                    renderInput={(params) => (
                      <TextField
                        autoComplete='off'
                        {...params}
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {customersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                  </div>
              </div>
            ) : null}
          </div>
          <div style={{ flex: 0, marginRight: 10 }}>
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerContractName'} />}
              variant="outlined"
              fullWidth
              required
              error={errors.name}
              value={customerContract.name}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('name', true, e.target.value)}
            />
            <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerContractStatus'} />}<span style={{ color: 'red' }}>*</span></h4>
            <Select
              options={_.map(CustomerContractStatusOptions, (v) => ({ value: v }))}
              isClearable
              isSearchable={false}
              placeholder={<ReduxLanguage languageKey={'credits.customerContractStatus'} />}
              getOptionLabel={(v) => translations.t(`credits.customerContractStatus_${v.value}`)}
              value={customerContract.status ? { value: customerContract.status } : null}
              onChange={(e) => this.onChangeValue('status', true, e ? e.value : null)}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
              }} 
            />
            <div style={{ flex: 1 }}>
              <div style={{ marginLeft: 0 }}>
                <h3 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3 }}>{<ReduxLanguage languageKey={'credits.customerContractSigningDate'} />}<span style={{ color: 'red' }}>*</span></h3>
                <KeyboardDatePicker
                  disableToolbar
                  style={{ width: '100%' }}
                  variant="dialog"
                  format="DD/MM/YYYY"
                  margin="dense"
                  inputVariant="outlined"
                  inputProps={{
                    className: classes.dateInput
                  }}
                  clearable
                  id="date-picker-inline"
                  placeholder={translations.t('forms.pickDate') + ' (dd/mm/yyyy)'}
                  value={customerContract.signingDate ? moment(customerContract.signingDate) : null}
                  onChange={e => this.onChangeValue('signingDate', true, e?.valueOf())}
                />
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ marginLeft: 0 }}>
                <h3 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3 }}>{<ReduxLanguage languageKey={'credits.customerContractExpirationDate'} />}<span style={{ color: 'red' }}>*</span></h3>
                <KeyboardDatePicker
                  disableToolbar
                  style={{ width: '100%' }}
                  variant="dialog"
                  format="DD/MM/YYYY"
                  margin="dense"
                  inputVariant="outlined"
                  inputProps={{
                    className: classes.dateInput
                  }}
                  clearable
                  id="date-picker-inline"
                  placeholder={translations.t('forms.pickDate') + ' (dd/mm/yyyy)'}
                  value={customerContract.expirationDate ? moment(customerContract.expirationDate) : null}
                  onChange={e => this.onChangeValue('expirationDate', true, e?.valueOf())}
                />
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ marginLeft: 0 }}>
                <h3 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3 }}>{<ReduxLanguage languageKey={'credits.customerContractActivationDate'} />}</h3>
                <KeyboardDatePicker
                  disableToolbar
                  style={{ width: '100%' }}
                  variant="dialog"
                  format="DD/MM/YYYY"
                  margin="dense"
                  inputVariant="outlined"
                  inputProps={{
                    className: classes.dateInput
                  }}
                  clearable
                  id="date-picker-inline"
                  placeholder={translations.t('forms.pickDate') + ' (dd/mm/yyyy)'}
                  value={customerContract.activationDate ? moment(customerContract.activationDate) : null}
                  onChange={e => this.onChangeValue('activationDate', false, e?.valueOf())}
                />
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ marginLeft: 0 }}>
                <h3 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3 }}>{<ReduxLanguage languageKey={'credits.customerContractDeactivationDate'} />}</h3>
                <KeyboardDatePicker
                  disableToolbar
                  style={{ width: '100%' }}
                  variant="dialog"
                  format="DD/MM/YYYY"
                  margin="dense"
                  inputVariant="outlined"
                  inputProps={{
                    className: classes.dateInput
                  }}
                  clearable
                  id="date-picker-inline"
                  placeholder={translations.t('forms.pickDate') + ' (dd/mm/yyyy)'}
                  value={customerContract.deactivationDate ? moment(customerContract.deactivationDate) : null}
                  onChange={e => this.onChangeValue('deactivationDate', false, e?.valueOf())}
                />
              </div>
            </div>
          </div>
          <div style={{ flex: 1, marginRight: 10 }}>
          </div>
          <div style={{position:'sticky',bottom:'0',paddingTop:'20px',backgroundColor:'white',marginLeft:'-20px',marginRight:'-20px',zIndex:1}}>
          <Button
            variant="contained"
            disabled={!this.canSubmitForm()}
            style={{ width: '100%', opacity: this.canSubmitForm() ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', borderRadius: 0, height: 45, fontWeight: 'bold'  }}
            onClick={() => this.onSubmitForm()}
          >
            <ReduxLanguage languageKey="forms.save" />
          </Button>
          </div>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    customersSearch: state.vars.customersSearch,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(CustomerContractForm));